import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { lg, changeLg, lge } from './language.js';
import * as serviceWorker from './serviceWorker';
// 全局变量设置
window.lg = lg; // 语言获取函数
window.changeLg = changeLg; // 改变语言函数
window.lge = lge;
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
